module.exports = __webpack_public_path__ + "static/img/s406.19167b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s406.png
// module id = 558
// module chunks = 3